export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const API_KEY = '98f12815-27cb-41d7-aa28-709e4838bc10';
export const TIMEOUT_SEC = 10;
export const PAGINATION = 10;
export const MODAL_CLOSE_SEC = 2;
